// Constants
import { VALID_TIME_MINSEC } from 'libs/utils/constants';

export function register(extend, i18n) {
    extend('time_minsec', {
        message: field => i18n.t('validations.time_minsec', [field]).toString(),
        validate: value => VALID_TIME_MINSEC.test(value)
    });
}
